<label class="switch">
  <input type="checkbox" [disabled]="disabled" (change)="onChange()" [(ngModel)]="value">
  <span class="slider">
    <span  [ngClass] = "{'showBar': showbar, 'hideBar': !showbar}"></span>
  </span>
</label>